import type { CoverageIncomplete } from "../api/client";

interface CoverageNoticeProps {
    anchor: string;
    coverage?: CoverageIncomplete | null;
}

/**
 * Shown when a /v1/stats request is rejected with `stats_coverage_incomplete`:
 * some selected countries have no data for the chosen period. Names only the
 * unavailable countries so the user can deselect them or pick a later period —
 * the FilterBar stays visible so the selection remains recoverable.
 */
export function CoverageNotice({ anchor, coverage }: CoverageNoticeProps) {
    if (!coverage) return null;

    const { unavailable } = coverage;
    const list = unavailable.join(", ");
    const plural = unavailable.length > 1;

    return (
        <div
            role="alert"
            style={{
                padding: "16px 20px",
                border: "1px solid rgb(var(--colour-semantic-caution, 245, 166, 35))",
                borderRadius: 8,
                background: "rgba(var(--colour-semantic-caution, 245, 166, 35), 0.08)",
            }}
        >
            <strong>
                No {anchor} data for {list} in this period.
            </strong>
            <p style={{ margin: "6px 0 0" }}>
                {plural ? "These countries have" : "This country has"} no data for the selected
                dates. Remove {plural ? "them" : "it"} from the country filter or choose a later
                period.
            </p>
        </div>
    );
}
